import React from 'react';

const RejectedBorderIcon = () => (
  <svg width="46" height="46" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter color-interpolation-filters="auto" id="a">
        <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.909804 0 0 0 0 0.247059 0 0 0 0 0.361330 0 0 0 1.000000 0"/>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect stroke="#E83F5C" stroke-width="2" x="1" y="1" width="44" height="44" rx="22"/>
      <g filter="url(#a)">
        <path d="m23.994 23 7.8-7.8a.703.703 0 1 0-.994-.994l-7.8 7.8-7.8-7.8a.703.703 0 1 0-.994.994l7.8 7.8-7.8 7.8a.703.703 0 1 0 .994.994l7.8-7.8 7.8 7.8a.7.7 0 0 0 .994 0 .703.703 0 0 0 0-.994l-7.8-7.8z" stroke="#E83F5C" stroke-width=".4" fill="#E83F5C" fillRule="nonzero"/>
      </g>
    </g>
  </svg>

);

export default RejectedBorderIcon;
